export default "__VITE_ASSET__UQBWFjvFigbLAtMFf$gFtQ__";